<template>
  <a-layout class="individual-layout">
    <IndividualInfoHeader/>
    <IndividualInfoTitle/>
    <IndividualScheduleDetailData @responseStatus="getResponseMsg"/>
    <ModalApiResultMsg :visible="responseMsgObj.visible" :title="responseMsgObj.title"
      :okText="responseMsgObj.okText" :cancelText="responseMsgObj.cancelText" :msgClass="responseMsgObj.msgClass"
      :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal"
      :cancelCallback="hideModal">
      <p>{{ responseMsgObj.detailText }}</p>
    </ModalApiResultMsg>
  </a-layout>
</template>

<script>
import IndividualInfoHeader from "../../components/individualInfo/IndividualInfoHeader.vue";
import IndividualInfoTitle from "../../components/individualInfo/IndividualInfoTitle.vue";
import IndividualScheduleDetailData from "../../components/individualInfo/IndividualScheduleDetailData.vue";
import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
import { mixinModalMethods } from "../../utils/mixins";
// import { mapActions } from 'vuex';

export default {
  name: 'IndividualScheduleDetailContainer',
  data() {
    return {
      // loaded: false,
      // deviceUid: '',
    };
  },
  // async beforeMount() {
  //   localStorage.clear();
  //   this.verifyIdentity();
  // },
  components: {
    IndividualInfoHeader,
    IndividualInfoTitle,
    IndividualScheduleDetailData,
    ModalApiResultMsg,
  },
  mixins: [mixinModalMethods],
  beforeRouteEnter(to, from, next) {

    // 檢查網址上的參數journeyCode是否為數字
    const isJourneyCodeNumber = !!parseInt(to.query.journeyCode, 10);

    let isDrivingDateValid = true;

    if(to.query.drivingDate){
      // 檢查網址上的參數drivingDate是否為8位數的數字
      isDrivingDateValid = to.query.drivingDate.length === 8 && /\d{8}/.test(to.query.drivingDate);
    }

    console.log("-----",to.query)
    // 如果網址上的參數journeyCode與drivingDate都不符合格式，導向行程列表頁面
    if (!isJourneyCodeNumber || !isDrivingDateValid) this.$router.push(`/individual/schedule?data=${encodeURIComponent(to.query.deviceUid)}`);
    else {
      sessionStorage.setItem('scheduleDetailPageFromPathName', from.name);
      next();
    }
  },
 /*  methods: {
    ...mapActions('identidyOpenStatus', ['deviceUidAction', 'openStatusAction']),
    ...mapActions('identidyInfo', ['identidyInfoAction']),
    async saveDeviceUid() {
      try {
        this.deviceUid = this.$route.query.data || '';
        console.log("deviceUid",this.deviceUid)
        this.deviceUidAction(this.deviceUid);
      } catch (error) {
        console.log(error);
      }
    },
    async verifyIdentity() {
      console.log("verifyIdentity")
      try {
        // this.isLoading = true;
        await this.saveDeviceUid();
        const params = {
          deviceUid: this.deviceUid,
        };
        const res = await this.openStatusAction(params);

        const { openedUser, carNo, openedMobile } = res;
        console.log('openedUser===', openedUser);
        await this.identidyInfoAction({
          name: openedUser,
          carNo: carNo,
          phone: openedMobile,
        });
        this.loaded = true;
        // console.log(this.loaded)
      } catch (error) {
        console.log('openStatus', error);
        // this.isLoading = false;
        // this.visible = true;
      }
    },
  }, */

}
</script>
